<template>
  <v-sheet v-if="formData.hasOwnProperty('id')">
    <v-layout row wrap>
      <v-flex xs12 md8 class="pb-0 pt-0">
        <h2 class="mb-0">{{ formData.name }}</h2>
      </v-flex>
      <v-flex xs12 md4 class="pt-0 mt-3">
        <v-autocomplete
          label="Report Visibility (On live site)"
          :items="visibilityStatus"
          item-text="title"
          item-value="value"
          v-model="formData.status"
        >
        </v-autocomplete>
      </v-flex>
      <v-flex xs12 md6>
        <v-flex xs12 class="autoMargin px-2">
          <template v-if="formData.id">
            <div v-if="formData.imageUrl && !changeImage">
              <v-img
                :src="formData.imageUrl"
                :width="300"
                :height="200"
                class="autoMargin"
              />
              <v-btn small block color="info" @click="changeImage = true"
                >Change Image</v-btn
              >
            </div>
            <croppa
              v-if="!formData.imageUrl || changeImage"
              v-model="image"
              :show-loading="true"
              :width="300"
              :height="200"
              :quality="2"
              canvas-color="#FFF"
              placeholder-color="#000000"
              placeholder="Choose formData image"
              style="width: 300px"
              initial-size="contain"
            />
            <div
              v-if="!formData.imageUrl || changeImage"
              class="caption text-xs-center"
            >
              Use scroll wheel to zoom in / out and drag to reposition.
            </div>
          </template>
        </v-flex>
      </v-flex>
      <v-flex xs12 md6>
        <v-layout row wrap>
          <v-flex xs12>
            <v-textarea
              v-model="formData.whoWeAre"
              label="Who we are"
              counter="700"
              maxlength="700"
              rows="12"
              :rules="[
                (v) => v.length <= 700 || 'Maximum of 700 characters allowed.',
              ]"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 md6>
        <v-text-field v-model="formData.website" hide-details label="Website" />
      </v-flex>
      <v-flex xs12 md6>
        <v-autocomplete
          v-model="formData.goodCause_id"
          :items="goodCauses"
          item-text="name"
          item-value="id"
          label="Chosen Good Cause / Area of Impact"
          placeholder="Please select"
        />
      </v-flex>
      <v-flex xs12>
        <v-btn :loading="saving" @click="save()" color="success"> Save </v-btn>
        <v-btn
          @click="$router.push(`/impactBusinessProfile/${formData.id}`)"
          color="ibColor"
          dark
        >
          View My Report
        </v-btn>
      </v-flex>
      <v-flex xs12>
        <p>
          <b style="font-size: 12pt">What is an Impact Report? </b>
          An impact report is a summary of the impact you have created through
          your purchases. This can be visible on the Impact Report tab on our
          website. View what your Impact Report looks like, by clicking the
          above "View my Report" button.
        </p>
      </v-flex>
    </v-layout>
  </v-sheet>
  <v-sheet v-else>
    <div style="margin: auto; width: 50px; padding-top: calc(50% - 25px)">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
  </v-sheet>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      userData: "user/userData",
      profile: "impactBusinesses/currentProfile",
      goodCauses: "goodCauses/listOrderedByCategories",
    }),
  },
  watch: {
    profile: function() {
      this.formData = JSON.parse(JSON.stringify(this.profile));
    },
  },
  data: () => ({
    changeImage: false,
    image: null,
    formData: {},
    visibilityStatus: [
      {
        value: "Live Report",
        title: "Report visible to public",
      },
      {
        value: "Data Only",
        title: "Report hidden from public",
      },
    ],
    saving: false,
  }),
  mounted() {
    this.$store.dispatch(
      "impactBusinesses/loadProfile",
      this.userData.impactBusiness_id
    );
  },
  methods: {
    save() {
      this.saving = true;
      // if (this.image && this.image.imageSet) {
      //   this.image.generateBlob(
      //     (blob) => {
      //       this.formData.image = { file: blob };
      //       this.$store
      //         .dispatch("impactBusinesses/save", this.formData)
      //         .then((business) => {
      //           this.$store.dispatch("impactBusinesses/loadAllAdmin");
      //           this.formData = business;
      //           this.formData.impactIsGC = parseInt(this.formData.impactIsGC);
      //           this.formData.goodCauseLinkEnabled = parseInt(
      //             this.formData.goodCauseLinkEnabled
      //           );
      //           this.changeImage = false;
      //           this.saving = false;
      //           this.$emit("saved");
      //           if (addNew == true) {
      //             this.formData = {
      //               status: "Data Only",
      //               impactInterestedStatus: "Prospecting",
      //             };
      //           } else if (this.$route.params.id == "new") {
      //             this.$router.push(
      //               `/admin/impactBusinessAdmin/${business.id}`
      //             );
      //           }
      //         });
      //     },
      //     "image/jpeg",
      //     0.9
      //   );
      // } else {
      if (this.image && this.image.imageSet) {
        this.formData.image = {
          dataUrl: this.image.generateDataUrl(),
        };
      } else {
        delete this.formData.image;
      }
      this.$store
        .dispatch("impactBusinesses/save", this.formData)
        .then((business) => {
          this.$store.dispatch("impactBusinesses/loadAllAdmin");
          this.changeImage = false;

          this.formData = business;
          this.saving = false;
        });
      // }
    },
  },
};
</script>
